//  export const formatMinutesAndHours = (minutes: number): string => {
//     const h = Math.floor(minutes / 60);
//     const m = minutes % 60;
//     return `${h}h ${m}m`;
//   };

//  export  const formatMinutesToHM = (minutes: number): string => {
//     const h = Math.floor(minutes / 60);
//     const m = minutes % 60;
//     return `${h ? h : 0}h ${m ? m : 0}m`;
//   };




export const formatFractionHourToHM = (hours: number): string => {
  if (!hours || hours < 0) return '0h 0m';
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);

  return `${h}h ${m}m`;
};
export const formatFractionMinutesToHM = (minutes: number): string => {
  if (!minutes || minutes < 0) return '0h 0m';
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  return `${h}h ${m}m`;
};
